import React from 'react'
import styles from './TRoutePhotos.scss'
import _ from 'lodash'
import {Image} from 'common/Image'
import {pl} from 'lib/textUtils'
import {showGallery} from 'features/gallery/showGallery'

export class TRoutePhotos extends React.PureComponent {
  render () {
    const {
      editable,
      objectType,
      onTriggerFileBrowser,
      pendingPhotoUploads,
      photos,
      troute,
      onPhotoDeleted
    } = this.props
    const orderedPhotos = _.orderBy(photos, ['capturedAt', 'id'], ['asc', 'asc'])
    const showGalleryWithProps = (activePhotoId) => showGallery({
      photos: orderedPhotos,
      readonly: !editable,
      parentType: objectType,
      parentId: troute.id,
      activePhotoId,
      onPhotoDeleted
    })

    if (photos.length === 0 && !pendingPhotoUploads) {
      return null
    }

    return (
      <div className={styles.TRoutePhotos}>
        {orderedPhotos.length === 1 && <Image
          id={orderedPhotos[0].id}
          width={360}
          height={240}
          onClick={() => showGalleryWithProps(orderedPhotos[0].id)} />}
        {orderedPhotos.length > 1 && <div className={styles.grid}>
          {orderedPhotos.slice(0, 6).map(p => (
            <Image key={p.id}
              id={p.id}
              width={112}
              height={112}
              onClick={() => showGalleryWithProps(p.id)} />
          ))}
        </div>}
        {orderedPhotos.length > 0 && <div className={styles.morePhotos}>
          <span><a onClick={showGalleryWithProps}>Open gallery</a> ({pl(photos.length, 'photo')})</span>
          {editable && <a onClick={onTriggerFileBrowser} data-tip title='You can also add photos by dragging them onto this page'>Add photos</a>}
        </div>}
      </div>
    )
  }
}
